/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useState } from 'react';
import { AiFillHeart } from 'react-icons/ai';
import placeholder from '../../../assets/images/placeholder.png';
import { FaThumbsDown, FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import moreTags from '../../../assets/images/more.png';
import LazyImage from '../../Utils/Components/lazyImageComponent';
import {
	BsExclamationTriangleFill,
	BsFillCheckCircleFill,
	BsHourglass,
	BsHourglassSplit,
	BsHourglassTop,
	BsSearch,
	BsXLg
} from 'react-icons/bs';
import RemoveModal from '../../Utils/Components/modals/removeModal';
import { useMutation } from 'react-query';
import { SetNotificationAction } from '../../../redux/actions/notificationAction';
import { useDispatch } from 'react-redux';
import axiosInstance from '../../../config/axiosInstance';
import { globalEnv } from '../../../config/baseConfig';
import { stateNotificationsEnum } from '../../Utils/notification';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import { text } from 'stream/consumers';

type TopicCardProps = {
	id: string;
	name: string;
	imagesCount: number;
	usersCount: number;
	image: any;
	creator: any;
	contributors: any;
	isContributor: boolean;
	tags: string[];
	isComplete: boolean;
	status: string;
	createdAt: string;

	topics: any[];
	setTopics: (topics: any[]) => void;
	reloadCount: number;
	setReloadCount: (count: number) => void;
};

function TopicCard({
	id,
	name,
	usersCount,
	image,
	creator,
	contributors,
	isContributor,
	tags,
	isComplete,
	status,
	topics,
	setTopics,
	reloadCount,
	setReloadCount
}: TopicCardProps) {
	const [allContributors, setAllContributors] = useState<any[]>(
		contributors.concat(creator)
	);
	const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const TagComponent = ({ name }: { name: string }) => {
		return (
			<div
				className="flex justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500 h-8
													bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
													dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
													dark:text-gray-300 text-gray-600 hover:text-gray-200"
			>
				<span className="text-xs font-bold mx-1">{name.toUpperCase()}</span>
			</div>
		);
	};

	const MoreTagsComponent = () => {
		return (
			<div
				className="flex justify-center items-center py-1.5 px-0.5 rounded-full w-fit transition-all duration-500 h-8
													bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
													dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
													dark:text-gray-300 text-gray-600 hover:text-gray-200"
			>
				<img src={moreTags} className="rounded-box object-cover h-8 w-8" />
			</div>
		);
	};

	interface IDeleteTopic {
		topicId: string;
	}
	const deleteTopicReq = async (params: IDeleteTopic) => {
		const { data: response } = await axiosInstance().delete(
			globalEnv.BASE_URL + '/editor/topic/delete',
			{
				data: {
					topicId: params.topicId
				},
				headers: {
					Authorization: 'Bearer ' + ACCESS_TOKEN
				}
			}
		);
		return response;
	};

	const dispatch = useDispatch();

	const { mutate } = useMutation(deleteTopicReq, {
		onSuccess: () => {
			setTopics(topics.filter((topic) => topic._id != id));
			setReloadCount(reloadCount + 1);

			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully deleted topic.'
				})
			);
		},
		onError: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "couldn't delete topic."
				})
			);
		}
	});

	const deleteTopic = (topicId: string) => {
		setIsRemoveModalOpen(false);
		mutate({ topicId });
	};

	const ReviewStatusIcon = ({
		icon,
		text,
		btnColor,
		translatePos
	}: {
		icon: any;
		text: string;
		btnColor: string;
		translatePos: boolean;
	}) => {
		return (
			<div className="group-1 absolute top-1 left-0">
				<button
					className={`absolute top-1 left-2 ${btnColor} btn-xs btn btn-circle btn-outline shadow-md 
					${translatePos && 'transform group-hover:translate-x-8'}`}
				>
					{icon}
				</button>
				<span
					className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs z-10
								scale-0 origin-left group-1-hover:scale-100 font-bold transition-all duration-500 opacity-0
								group-1-hover:opacity-100 top-0 left-18"
				>
					{text}
				</span>
			</div>
		);
	};

	const navigate = useNavigate();
	return (
		<div
			className="bg-gray-200 dark:bg-gray-700 hover:bg-gray-800 dark:hover:bg-gray-200
			shadow-xl hover:shadow-none cursor-pointer w-full rounded-3xl flex flex-col
            transition-all duration-500 ease-in-out group mb-2"
			onClick={() => {
				navigate(`../topic/${id}`);
			}}
		>
			<div>
				<RemoveModal
					title={'Remove Topic'}
					text={'Are you sure you want to remove this topic?'}
					setModalOpen={setIsRemoveModalOpen}
					setAction={() => deleteTopic(id)}
					visible={isRemoveModalOpen}
				/>
			</div>
			<div className="relative flex flex-col mt-2 mx-2">
				<div className="w-full xl:min-h-[200px] xl:min-w-[300px] rounded-2xl overflow-hidden">
					<div className="overflow-hidden">
						<LazyImage
							photo={
								image != null
									? image.url_low_res != null
										? image.url_low_res
										: placeholder
									: placeholder
							}
							style={
								'block object-cover object-center w-full aspect-[16/10] rounded-lg max-h-[240px]'
							}
							placeholderStyle={
								'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'
							}
							loaderDimesnions={120}
						/>
					</div>

					{!isContributor && (
						<div className="group-1 opacity-0 group-hover:opacity-100 transition-all duration-300">
							<button
								className="absolute top-2 left-2 btn-error btn-xs btn btn-circle btn-outline shadow-md z-20"
								onClick={(e) => {
									e.stopPropagation();
									setIsRemoveModalOpen(true);
								}}
							>
								<BsXLg />
							</button>
							<span
								className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs z-20
									  scale-0 origin-left group-1-hover:scale-100
						              font-bold transition-all duration-500 opacity-0 group-1-hover:opacity-100 top-1 left-10"
							>
								{'Remove ❌'}
							</span>
						</div>
					)}

					{status != null ? (
						status === 'accepted' || status === 'featured' ? (
							<ReviewStatusIcon
								icon={<BsFillCheckCircleFill />}
								text={'Approved ✅'}
								btnColor={'btn-success'}
								translatePos={!isContributor}
							/>
						) : status === 'rejected' ? (
							<ReviewStatusIcon
								icon={<BsExclamationTriangleFill />}
								text={'Rejected❗'}
								btnColor={'btn-error'}
								translatePos={!isContributor}
							/>
						) : status === 'additional review' ? (
							<ReviewStatusIcon
								icon={<BsHourglassSplit />}
								text={'Additional review 🔍'}
								translatePos={!isContributor}
								btnColor={''}
							/>
						) : (
							<ReviewStatusIcon
								icon={<BsHourglassTop />}
								text={'Pending review 🔍'}
								btnColor={'btn-warning'}
								translatePos={!isContributor}
							/>
						)
					) : (
						<ReviewStatusIcon
							icon={<BsSearch />}
							text={'Pending review 🔍'}
							btnColor={'btn-warning'}
							translatePos={!isContributor}
						/>
					)}
				</div>

				<div className=" flex flex-row w-full min-h-8">
					<div className="pt-1 w-1/2 px-1">
						<h1 className="font-medium whitespace-nowrap leading-none text-base tracking-wider text-gray-800 dark:text-white group-hover:text-white dark:group-hover:text-gray-800">
							{name}
						</h1>
					</div>

					<div className="flex flex-row space-x-2 ml-auto mb-1">
						{tags != null &&
							(tags.length < 3 ? (
								tags.map((tag) => <TagComponent name={tag} />)
							) : (
								<>
									{tags.slice(0, 2).map((tag) => (
										<TagComponent name={tag} />
									))}
									<MoreTagsComponent />
								</>
							))}
					</div>
				</div>
			</div>
			<div className="flex flex-row w-full px-2 overflow-hidden">
				<div className=" flex flex-row justify-start w-1/2">
					<div
						className="h-8 w-8 group-1 flex items-center justify-center bg-white dark:bg-gray-800 hover:bg-red-500 dark:hover:bg-red-500
                     text-red-500 hover:text-white rounded-2xl shadow-xl transform-gpu translate-y-0 hover:-translate-y-1 
                     transition-all duration-300 ease-in-out"
					>
						<AiFillHeart size={16} />

						<span
							className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
									  scale-0 origin-top group-1-hover:scale-100
						              font-bold transition-all duration-500 opacity-0 group-1-hover:opacity-100 top-10 left-1/2 transform -translate-x-1/2"
						>
							{'Love count: 0'}
						</span>
					</div>
					<div
						className="h-8 w-8 group-1 ml-1 flex items-center justify-center bg-white dark:bg-gray-800 hover:bg-gray-500 dark:hover:bg-red-500
                     text-gray-500 hover:text-white rounded-2xl shadow-xl transform-gpu translate-y-0 hover:-translate-y-1 
                     transition-all duration-300 ease-in-out"
					>
						<FaThumbsDown size={16} />

						<span
							className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
									  scale-0 origin-top group-1-hover:scale-100
						              font-bold transition-all duration-500 opacity-0 group-1-hover:opacity-100 top-10 left-1/2 transform -translate-x-1/2"
						>
							{'Dislike count: 0'}
						</span>
					</div>
					<div
						className="relative h-8 w-fit ml-3 bg-white dark:bg-gray-800 hover:bg-blue-600 dark:hover:bg-blue-600 flex items-center align-middle
                        justify-center font-medium text-blue-600 hover:text-white rounded-2xl shadow-xl
                        transform-gpu translate-y-0 transition-all duration-300 ease-in-out group-1"
					>
						<FaUser size={14} className="ml-2" />
						<span className="text-sm text-gray-800 dark:text-white ml-1 mr-2 -mt-0.5 group-1-hover:text-white dark:group-1-hover:text-white mx-2">
							{usersCount}
						</span>
					</div>
				</div>

				<div className="flex w-1/2 justify-end pt-1 mb-2">
					{allContributors.map((item) => (
						<div
							onClick={(e) => {
								if (allContributors.length > 0) {
									e.stopPropagation();
									navigate(`../user/${item._id}`);
								}
							}}
						>
							<div className="mr-0.5 h-7">
								<LazyImage
									photo={
										item.photo != null
											? item.photo
											: `https://api.dicebear.com/7.x/bottts/svg?seed=${item.username}`
									}
									dimesnions={{ width: '23', height: '23' }}
									loaderDimesnions={23}
								/>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}

export default TopicCard;
